

import ProfileInfo from 'components/ProfileInfo'
import SecuritySettings from 'components/SecuritySettings'

import React from 'react'

const MainProfile = () => {
  return (
    <>
      <div className="mb-1 container mx-auto px-2 lg-px-4 mt-8 text-center">
        <h1 className="text-2xl font-bold text-neonPurple glow-text mb-1">Profile Dashboard</h1>
        <p className="text-gray-400 max-w-2xl mx-auto">
          Manage your account settings, security preferences, & telegram alerts configuration
        </p>
      </div>

      <div className="grid grid-cols-1 container mx-auto px-2 lg-px-4  md:grid-cols-2  ">
        <div className=" "><ProfileInfo /></div>
        <div className="  "><SecuritySettings /></div>
      </div>

    </>
  )
}

export default MainProfile